import { Outlet, NavLink } from 'react-router-dom';
import { useSectionTranslation } from '@/hooks';
import { useDocumentTitle } from '@/hooks';
import { settingsTranslations } from './translations';
import { User, ShieldCheck, Link2, Bell } from 'lucide-react';
import { Header } from '@/features/home/Header';

const tabs = [
  { key: 'profile' as const, icon: User, to: '/settings/profile' },
  { key: 'security' as const, icon: ShieldCheck, to: '/settings/security' },
  { key: 'linkedAccounts' as const, icon: Link2, to: '/settings/linked-accounts' },
  { key: 'notifications' as const, icon: Bell, to: '/settings/notifications' },
];

export function SettingsLayout() {
  const t = useSectionTranslation(settingsTranslations);
  useDocumentTitle(t.title);

  return (
    <div className="min-h-screen bg-surface-base">
      <Header />
      <div className="pt-20 pb-16">
        <div className="container-main">
          <h1 className="font-display text-display-lg text-brand-white mb-8">{t.heading}</h1>
          <div className="flex flex-col md:flex-row gap-8">
            <nav className="md:w-56 shrink-0 space-y-1" aria-label="Settings tabs">
              {tabs.map((tab) => (
                <NavLink
                  key={tab.key}
                  to={tab.to}
                  end
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-surface-card text-brand-white border border-surface-border'
                        : 'text-brand-muted hover:text-brand-white hover:bg-surface-hover'
                    }`
                  }
                >
                  <tab.icon size={16} />
                  {t.tabs[tab.key]}
                </NavLink>
              ))}
            </nav>
            <div className="flex-1 min-w-0">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}